// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/sass/base.scss'

// import VueTinymce from "@packy-tang/vue-tinymce"

// Vue.use(VueTinymce);
Vue.use(ElementUI);

// 统一确认弹窗：必须在 Vue.use(ElementUI) 之后，否则原型方法被 Element 覆盖回去
import confirmPlugin from './assets/js/confirm'
Vue.use(confirmPlugin);

Vue.prototype.$api = require('./assets/js/api/common.js').default;
Vue.prototype.$util = require('./assets/js/util/util.js').default;
Vue.prototype.$config = require('./assets/js/config.js').default;

import uploadFrom from './components/uploadFrom';
Vue.prototype.bus = new Vue();
Vue.use(uploadFrom);
import uploadPicture from './components/base/uploadPicture.vue';
Vue.component('UploadPicture',uploadPicture)
import Upload from './components/Upload.vue'
Vue.component('Upload',Upload)
import MoreImage from './components/MoreImage.vue'
Vue.component('MoreImage',MoreImage)
import Editor from './components/Editor.vue'
Vue.component('Editor',Editor)
import FileSize from './components/FileSize.vue'
Vue.component('FileSize',FileSize)
import EmptyBox from './components/EmptyBox.vue'
Vue.component('EmptyBox',EmptyBox)
import CImage from './components/CImage.vue'
Vue.component('CImage',CImage)
import ImportFile from './components/ImportFile.vue'
Vue.component('ImportFile',ImportFile)
import Tinymce from './components/Tinymce'
Vue.component('Tinymce',Tinymce)
import SelectClass from './components/SelectClass.vue'
Vue.component('SelectClass',SelectClass)

import scroll from 'vue-seamless-scroll';
Vue.use(scroll);
import EditorPreview from './components/EditorPreview.vue';
Vue.component('EditorPreview',EditorPreview)
import AmapVue from '@amap/amap-vue';
AmapVue.config.version = '2.0'; // 默认2.0，这里可以不修改
AmapVue.config.key = 'aa8b4409a8723c98676b0cb4bdb445fb';
AmapVue.config.plugins = [
  // 在此配置你需要预加载的插件，如果不配置，在使用到的时候会自动异步加载
];
Vue.use(AmapVue);

import store from './store/store'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js